// ADVANCED function to trigger the explosion animation
function triggerExplosionAnimation(button) {
  const animationContainer = document.getElementById('product-added-animation-container');
  if (!animationContainer) return;

  const buttonRect = button.getBoundingClientRect();
  const scrollY = window.scrollY || document.documentElement.scrollTop;

  // Position the container's center right on top of the button's center
  animationContainer.style.left = `${buttonRect.left + (buttonRect.width / 2)}px`;
  animationContainer.style.top = `${buttonRect.top + (buttonRect.height / 2)}px`;

  // Activate the animation
  animationContainer.classList.add('active');

  // Deactivate after the animation is finished
  setTimeout(() => {
    animationContainer.classList.remove('active');
  }, 3000);
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        
        // --- TRIGGER THE NEW ANIMATION ---
        triggerExplosionAnimation(this.submitButton);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                  setTimeout(() => { this.cart.renderContents(response); });
                }, { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // --- DELAY CART DRAWER TO ALLOW ANIMATION TO PLAY ---
              setTimeout(() => {
                this.cart.renderContents(response);
                if (window.updateFreeShippingMessage) {
                  window.updateFreeShippingMessage();
                }
              }, 1000); // 1-second delay
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // THIS FUNCTION IS NOW RESTORED
      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButton.querySelector('span').textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.querySelector('span').textContent = window.variantStrings.addToCart;
        }
      }

      // THIS FUNCTION IS NOW RESTORED
      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}